var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAverage = function SvgAverage(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 0a13.94 13.94 0 0 1 8.384 2.787L24.586.586a2 2 0 0 1 2.945 2.701l-.117.127-2.2 2.202A13.94 13.94 0 0 1 28 14c0 7.732-6.268 14-14 14a13.94 13.94 0 0 1-8.384-2.787l-2.202 2.201A2 2 0 0 1 .47 24.713l.117-.127 2.2-2.202A13.94 13.94 0 0 1 0 14C0 6.268 6.268 0 14 0m8.343 8.486L8.486 22.343A9.95 9.95 0 0 0 14 24c5.523 0 10-4.477 10-10a9.95 9.95 0 0 0-1.657-5.514M14 4C8.477 4 4 8.477 4 14a9.95 9.95 0 0 0 1.657 5.514L19.514 5.657A9.95 9.95 0 0 0 14 4"
  })));
};
export default SvgAverage;